export default function MaskIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.75 1.75L12.25 12.25"
        stroke="#7953D2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.15023 3.63484C2.89356 3.82734 2.65848 4.03034 2.4444 4.23684C1.72943 4.93122 1.1375 5.74189 0.693812 6.63434C0.638563 6.74846 0.609863 6.8736 0.609863 7.00039C0.609863 7.12717 0.638563 7.25231 0.693812 7.36643C1.13727 8.25904 1.729 9.06992 2.44381 9.76451C3.46523 10.7474 4.96906 11.6673 7.00023 11.6673C8.30456 11.6673 9.3919 11.2882 10.2727 10.7562L7.97206 8.45609C7.63543 8.68096 7.23125 8.78215 6.82837 8.74244C6.42549 8.70273 6.04884 8.52458 5.76259 8.23832C5.47633 7.95206 5.29817 7.57541 5.25846 7.17254C5.21875 6.76966 5.31995 6.36548 5.54481 6.02884L3.15023 3.63484ZM12.0554 9.23951C12.5514 8.67185 12.972 8.04247 13.3066 7.36701C13.3619 7.2529 13.3906 7.12775 13.3906 7.00097C13.3906 6.87418 13.3619 6.74904 13.3066 6.63493C12.8632 5.74231 12.2715 4.93144 11.5566 4.23684C10.5352 3.25393 9.03198 2.33401 7.00023 2.33401C6.4473 2.33241 5.89657 2.4036 5.36223 2.54576L12.0554 9.23951Z"
        fill="#7953D2"
      />
    </svg>
  );
}
